// extracted by mini-css-extract-plugin
module.exports = {"info":"MainPage_info__1ddVA"};